const LETTERS: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'h', ґ: 'g', д: 'd', е: 'e', є: 'ie', ж: 'zh', з: 'z', и: 'y', і: 'i', ї: 'i', й: 'i', к: 'k', л: 'l', м: 'm',
  н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'kh', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch', ю: 'iu', я: 'ia',
};
const WORD_START: Record<string, string> = { є: 'ye', ї: 'yi', й: 'y', ю: 'yu', я: 'ya' };
const MAX_LENGTH = 48;

/**
 * Адреса простору в підказці під назвою (прототип v4 onbSlug) — так, як її складе сервер (WorkspaceSlug.From): українська транслітерація
 * (КМУ № 55: «є, ї, й, ю, я» на початку слова — ye, yi, y, yu, ya; «зг» — zgh; м’який знак і апостроф не передаються), латиниця й цифри
 * як є, решта — дефіс, до 48 символів; порожня назва — your-workspace. Чиста функція.
 */
export function onboardSlug(name: string): string {
  let out = '';
  let prev = '';
  for (const ch of name.trim().toLowerCase()) {
    if (ch === 'ь' || ch === "'" || ch === '’' || ch === 'ʼ') continue;
    const wordStart = !/\p{L}/u.test(prev);
    if (ch === 'г' && prev === 'з') out += 'gh';
    else if (wordStart && WORD_START[ch]) out += WORD_START[ch];
    else if (LETTERS[ch]) out += LETTERS[ch];
    else out += /[a-z0-9]/.test(ch) ? ch : '-';
    prev = ch;
  }
  const slug = out.replace(/-+/g, '-').replace(/^-|-$/g, '').slice(0, MAX_LENGTH).replace(/-+$/, '');
  return slug || 'your-workspace';
}
